namespace Areas.Analysis.MilestonesCrosstab {
    "use strict";

    export function goToProjectFromGrid(e: any) {
        const dataGrid = $("#MilestonesCrosstabGrid").dxDataGrid("instance");
        const rows = dataGrid.getSelectedRowsData();
        if (rows.length == 1) {
            location.href = "/Project/Profile/View/" + rows[0].projectId;
        }
        else {
            DevExpress.ui.notify("You need to select a row first!", "warning", 2000);
        }

    }


    export function columnViewLink(cellElement: any, cellInfo: any) {
        let linkInfo = "<a href= '/Project/Profile/View/{placeholder}'>View</a>";

        buildCellContent(cellElement,
            () => { return cellInfo.data.projectId; },
            linkInfo);
    }


    export function onCellPrepared(e: any) {
        if (e.rowType !== "data") {
            return;
        }
        setDateCellBackground(e);
    }

    function setDateCellBackground(e) {
        var demoPermitDate = e.column.dataField === "demolitionPermitDate";
        var demoPermitCount = e.column.dataField === "demolitionPermitCount";

        if (demoPermitDate) {
            if (e.data.demoPermitCount === 0 && e.data.demoPermitDate !== null) {
                e.cellElement.css('background-color','yellow')
            }
            else if (e.data.demoPermitCount > 0 && e.data.demoPermitDate === null) {
                e.cellElement.css('background-color', 'red')
            }
        }

        var permitDate = e.column.dataField === "permitDate";
        var permitCount = e.column.dataField === "permitCount";

        if (permitDate) {
            if (e.data.permitCount === 0 && e.data.permitDate !== null) {
                e.cellElement.css('background-color', 'yellow')
            }
            else if (e.data.permitCount > 0 && e.data.permitDate === null) {
                e.cellElement.css('background-color', 'red')
            }
        }

        var tcoDate = e.column.dataField === "tcoDate";
        var tcoCount = e.column.dataField === "tcoCount";

        if (tcoDate) {
            if (e.data.tcoCount === 0 && e.data.tcoDate !== null) {
                e.cellElement.css('background-color', 'yellow')
            }
            else if (e.data.tcoCount > 0 && e.data.tcoDate === null) {
                e.cellElement.css('background-color', 'red')
            }
        }

        var coDate = e.column.dataField === "coDate";
        var coCount = e.column.dataField === "coCount";

        if (coDate) {
            if (e.data.coCount === 0 && e.data.coDate !== null) {
                e.cellElement.css('background-color', 'yellow')
            }
            else if (e.data.coCount > 0 && e.data.coDate === null) {
                e.cellElement.css('background-color', 'red')
            }
        }


        var boDate = e.column.dataField === "boDate";
        var boCount = e.column.dataField === "boCount";

        if (boDate) {
            if (e.data.boCount === 0 && e.data.boDate !== null) {
                e.cellElement.css('background-color', 'yellow')
            }
            else if (e.data.boCount > 0 && e.data.boDate === null) {
                e.cellElement.css('background-color', 'red')
            }
        }

        var scDate = e.column.dataField === "scDate";
        var scCount = e.column.dataField === "scCount";

        if (scDate) {
            if (e.data.scCount === 0 && e.data.scDate !== null) {
                e.cellElement.css('background-color', 'yellow')
            }
            else if (e.data.scCount > 0 && e.data.scDate === null) {
                e.cellElement.css('background-color', 'red')
            }
        }

        var iaDate = e.column.dataField === "iaDate";
        var iaCount = e.column.dataField === "iaCount";

        if (iaDate) {
            if (e.data.iaCount === 0 && e.data.iaDate !== null) {
                e.cellElement.css('background-color', 'yellow')
            }
            else if (e.data.iaCount > 0 && e.data.iaDate === null) {
                e.cellElement.css('background-color', 'red')
            }
        }

        var ncDate = e.column.dataField === "ncDate";
        var ncCount = e.column.dataField === "ncCount";

        if (ncDate) {
            if (e.data.ncCount === 0 && e.data.ncDate !== null) {
                e.cellElement.css('background-color', 'yellow')
            }
            else if (e.data.ncCount > 0 && e.data.ncDate === null) {
                e.cellElement.css('background-color', 'red')
            }
        }


    }

}